export default "/assets/images/mila-with-dimensions.png?8739fb0c200e5a549aa50febb15c0a1a";